export default {
    popupBody: {
        padding: "10px 20px 40px",
    },

    rowsGap: {
        rowGap: "10px"
    }
}